module.exports = __webpack_public_path__ + "static/summit-shaper-b56c5b1d25ef1c68a4fcb8193cd9d48a.png";